import React from "react";
import "./CreateIssueModal.css";
import { connect } from "react-redux";
import {
  hideCreateAction,
  loadIssueRequestAction
} from "../../redux/actions/issueList";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import ProgressBar from "react-bootstrap/ProgressBar";
import Button from "react-bootstrap/Button";
import Dropzone from "react-dropzone";
import { createWebIssueApi, createPdfIssueApi } from "../../api/issues";

class CreateIssueModal extends React.Component {
  constructor(props) {
    super(props);

    this.handleCloseCreateModal = this.handleCloseCreateModal.bind(this);
    this.handleEnterCreatingIssue = this.handleEnterCreatingIssue.bind(this);
    this.handleFireCreateIssue = this.handleFireCreateIssue.bind(this);
    this.handleEnterPubuID = this.handleEnterPubuID.bind(this);
    this.handleEnterPubuCategory = this.handleEnterPubuCategory.bind(this);
    this.handleSelectPdf = this.handleSelectPdf.bind(this);
    this.handleSelectXml = this.handleSelectXml.bind(this);
    this.handleProgress = this.handleProgress.bind(this);
    this.retreiveXmlInfo = this.retreiveXmlInfo.bind(this);
    this.handleEnterProductID = this.handleEnterProductID.bind(this);
    this.handleEnterContentsID = this.handleEnterContentsID.bind(this);

    this.state = {
      creatingIssueID: "",
      isCreating: false,
      creatingPubuID: "",
      creatingPubuCategory: "",
      creatingPdfFile: null,
      creatingXmlFile: null,
      progressPercent: 0,
      creatingContentsID: "",
      creatingProductID: ""
    };
  }

  handleCloseCreateModal() {
    const isPdf = this.props.bookType === "pdf_books";
    this.props.hideCreateAction({ isPdf });

    this.setState({
      creatingIssueID: "",
      isCreating: false,
      creatingPubuID: "",
      creatingPubuCategory: "",
      creatingPdfFile: null,
      creatingXmlFile: null,
      progressPercent: 0,
      creatingContentsID: "",
      creatingProductID: ""
    });
  }

  handleEnterCreatingIssue(event) {
    if (this.state.isCreating) {
      return;
    }

    this.setState({
      creatingIssueID: event.target.value
    });
  }

  handleEnterPubuID(event) {
    if (this.state.isCreating) {
      return;
    }

    this.setState({
      creatingPubuID: event.target.value
    });
  }

  handleEnterContentsID(event) {
    if (this.state.isCreating) {
      return;
    }

    this.setState({
      creatingContentsID: event.target.value
    });
  }

  handleEnterProductID(event) {
    if (this.state.isCreating) {
      return;
    }

    this.setState({
      creatingProductID: event.target.value
    });
  }

  handleProgress(progress) {
    this.setState({
      progressPercent: progress
    });
  }

  handleEnterPubuCategory(event) {
    if (this.state.isCreating) {
      return;
    }

    this.setState({
      creatingPubuCategory: event.target.value
    });
  }

  handleSelectPdf(files) {
    if (files.length < 1) {
      return;
    }

    const file = files[0];

    if (!file.name.toLowerCase().endsWith(".pdf")) {
      toast.error("Only *.pdf file is allowed");
      return;
    }

    this.setState({
      creatingPdfFile: file
    });
  }

  handleSelectXml(files) {
    if (files.length < 1) {
      return;
    }

    const file = files[0];

    if (!file.name.toLowerCase().endsWith(".xml")) {
      toast.error("Only *.xml file is allowed");
      return;
    }

    this.parseXml(file).then(xmlParsedResult => {
      if (xmlParsedResult.coverDate !== "") {
        this.setState({
          creatingIssueID: xmlParsedResult.coverDate,
          creatingContentsID: xmlParsedResult.contentsID,
          creatingProductID: xmlParsedResult.productID
        });
      }
    });

    this.setState({
      creatingXmlFile: file
    });
  }

  handleFireCreateIssue() {
    if (
      this.state.creatingIssueID == null ||
      this.state.creatingIssueID === ""
    ) {
      toast.error("issue cannot be empty");
      return;
    }

    const isPdf = this.props.bookType === "pdf_books";

    if (isPdf) {
      if (this.state.creatingPdfFile == null) {
        toast.error("Please select a PDF file");
        return;
      }

      const {
        creatingIssueID,
        creatingPdfFile,
        creatingPubuID,
        creatingPubuCategory,
        creatingXmlFile,
        creatingContentsID,
        creatingProductID
      } = this.state;

      this.createPdfIssueRequest(
        this.props.titleID,
        creatingIssueID,
        creatingPdfFile,
        creatingPubuID,
        creatingPubuCategory,
        creatingXmlFile,
        creatingContentsID,
        creatingProductID
      );
    } else {
      this.createWebIssueRequest(
        this.props.titleID,
        this.state.creatingIssueID
      );
    }
  }

  retreiveXmlInfo(xmlDoc) {
    let xmlParsedResult = {};

    try {
      xmlParsedResult.contentsID = xmlDoc.getElementsByTagName(
        "ContentsID"
      )[0].childNodes[0].nodeValue;
    } catch (e) {
      xmlParsedResult.contentsID = "";
    }

    try {
      xmlParsedResult.scheduleID = xmlDoc.getElementsByTagName(
        "ScheduleID"
      )[0].childNodes[0].nodeValue;
    } catch (e) {
      xmlParsedResult.scheduleID = "";
    }

    try {
      xmlParsedResult.productID = xmlDoc.getElementsByTagName(
        "ProductID"
      )[0].childNodes[0].nodeValue;
    } catch (e) {
      xmlParsedResult.productID = "";
    }

    try {
      xmlParsedResult.availableFrom = xmlDoc.getElementsByTagName(
        "SalesFromDateTime"
      )[0].childNodes[0].nodeValue;
    } catch (e) {
      xmlParsedResult.availableFrom = "";
    }

    try {
      xmlParsedResult.availableTo = xmlDoc.getElementsByTagName(
        "SalesToDateTime"
      )[0].childNodes[0].nodeValue;
    } catch (e) {
      xmlParsedResult.availableTo = "";
    }

    try {
      xmlParsedResult.coverDate = xmlDoc.getElementsByTagName(
        "CoverDate"
      )[0].childNodes[0].nodeValue;
    } catch (e) {
      xmlParsedResult.coverDate = "";
    }

    const contentID =
      xmlParsedResult.scheduleID !== ""
        ? xmlParsedResult.scheduleID
        : xmlParsedResult.contentsID;
    if (contentID !== "") {
      xmlParsedResult.contentsID = contentID;
    }

    const replaceContentID =
      contentID === "" ? "" : contentID.substr(0, 10) + "000000";
    const productID =
      xmlParsedResult.productID !== ""
        ? xmlParsedResult.productID
        : replaceContentID;
    if (productID !== "") {
      xmlParsedResult.productID = productID;
    }

    return xmlParsedResult;
  }

  parseXml(xmlFile) {
    const retreiveXmlInfo = this.retreiveXmlInfo;

    let promise = new Promise(function(resolve, reject) {
      let reader = new FileReader();
      reader.onload = function() {
        let text = reader.result;

        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(text, "text/xml");

        resolve(retreiveXmlInfo(xmlDoc));
      };
      reader.readAsText(xmlFile);
    });

    return promise;
  }

  async createPdfIssueRequest(
    titleID,
    issueID,
    pdfFile,
    pubuID,
    pubuCategory,
    xmlFile,
    contentsID,
    productID
  ) {
    this.setState({
      isCreating: true,
      progressPercent: 0
    });

    try {
      let xmlParsedResult;
      if (xmlFile != null) {
        xmlParsedResult = await this.parseXml(xmlFile);
      }

      await createPdfIssueApi(
        titleID,
        issueID,
        pdfFile,
        pubuID,
        pubuCategory,
        xmlParsedResult,
        this.handleProgress,
        productID,
        contentsID
      );

      this.setState({
        creatingIssueID: "",
        isCreating: false,
        creatingPubuID: "",
        creatingPubuCategory: "",
        creatingContentsID: "",
        creatingProductID: "",
        creatingPdfFile: null,
        creatingXmlFile: null,
        progressPercent: 0
      });

      this.props.hideCreateAction({ isPdf: true });
      this.props.loadIssueRequestAction(titleID, true);
    } catch (e) {
      this.setState({
        isCreating: false
      });

      toast.error(e.toString());
    }
  }

  async createWebIssueRequest(titleID, issueID) {
    this.setState({
      isCreating: true
    });

    try {
      await createWebIssueApi(titleID, issueID);

      this.setState({
        creatingIssueID: "",
        isCreating: false,
        creatingPubuID: "",
        creatingPubuCategory: "",
        creatingContentsID: "",
        creatingProductID: "",
        creatingPdfFile: null,
        creatingXmlFile: null,
        progressPercent: 0
      });

      this.props.hideCreateAction({ isPdf: false });
      this.props.loadIssueRequestAction(titleID, false);
    } catch (e) {
      this.setState({
        isCreating: false
      });

      toast.error(e.toString());
    }
  }

  renderWebCreator() {
    return (
      <Modal
        backdrop="static"
        show={this.props.showCreateModal}
        onHide={this.handleCloseCreateModal}
        centered
      >
        <Modal.Header>
          <Modal.Title>Create new web issues</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Control
            autoFocus
            value={this.state.creatingIssueID}
            type="text"
            placeholder="Unique web issue"
            onChange={this.handleEnterCreatingIssue}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={this.handleCloseCreateModal}
            disabled={this.state.isCreating}
          >
            Close
          </Button>
          <Button
            variant="info"
            onClick={this.handleFireCreateIssue}
            disabled={this.state.isCreating}
          >
            Create
          </Button>
          <div className="spinner_container">
            {" "}
            {this.state.isCreating && <Spinner animation="grow" />}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  renderPdfCreator() {
    return (
      <Modal
        backdrop="static"
        show={this.props.showCreateModal}
        onHide={this.handleCloseCreateModal}
        centered
      >
        <Modal.Header>
          <Modal.Title>Create a new PDF issue</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group autoFocus controlId="createPdfForms">
            <Form.Label>Issue Name</Form.Label>
            <Form.Control
              className="create_pdf_form"
              value={this.state.creatingIssueID}
              type="text"
              placeholder="Unique PDF Issue Name"
              onChange={this.handleEnterCreatingIssue}
            />
            <Form.Label>
              {process.env.REACT_APP_REGION === "JP"
                ? "Contents ID"
                : "Pubu ID"}
            </Form.Label>
            <Form.Control
              className="create_pdf_form"
              value={
                process.env.REACT_APP_REGION === "JP"
                  ? this.state.creatingContentsID
                  : this.state.creatingPubuID
              }
              type="text"
              placeholder={
                process.env.REACT_APP_REGION === "JP"
                  ? "Contents ID"
                  : "Pubu Product ID"
              }
              onChange={
                process.env.REACT_APP_REGION === "JP"
                  ? this.handleEnterContentsID
                  : this.handleEnterPubuID
              }
            />
            <Form.Label>
              {process.env.REACT_APP_REGION === "JP"
                ? "Product ID"
                : "Pubu Category"}
            </Form.Label>
            <Form.Control
              className="create_pdf_form"
              value={
                process.env.REACT_APP_REGION === "JP"
                  ? this.state.creatingProductID
                  : this.state.creatingPubuCategory
              }
              type="text"
              placeholder={
                process.env.REACT_APP_REGION === "JP"
                  ? "Product ID"
                  : "Pubu Product Category"
              }
              onChange={
                process.env.REACT_APP_REGION === "JP"
                  ? this.handleEnterProductID
                  : this.handleEnterPubuCategory
              }
            />
          </Form.Group>
          <Container>
            <Row>
              <Col>
                <Dropzone
                  disabled={this.state.isCreating}
                  onDrop={this.handleSelectPdf}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className={
                        this.state.creatingPdfFile == null
                          ? "upload_zone"
                          : "upload_zone_green"
                      }
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />
                      <span>
                        {this.state.creatingPdfFile == null
                          ? "Drop/Click PDF file"
                          : this.state.creatingPdfFile.name}
                      </span>
                    </div>
                  )}
                </Dropzone>
              </Col>
            </Row>
            <Row className="bottom_file_area">
              <Col>
                <Dropzone
                  disabled={this.state.isCreating}
                  onDrop={this.handleSelectXml}
                >
                  {({ getRootProps, getInputProps }) => (
                    <div
                      className={
                        this.state.creatingXmlFile == null
                          ? "upload_zone"
                          : "upload_zone_green"
                      }
                      {...getRootProps()}
                    >
                      <input {...getInputProps()} />

                      <span>
                        {this.state.creatingXmlFile == null
                          ? "Drop/Click Fujisan XML file"
                          : this.state.creatingXmlFile.name}
                      </span>
                    </div>
                  )}
                </Dropzone>
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          {this.state.isCreating && (
            <ProgressBar
              animated
              className="upload_progress"
              now={this.state.progressPercent}
            />
          )}
          <Button
            variant="secondary"
            onClick={this.handleCloseCreateModal}
            disabled={this.state.isCreating}
          >
            Close
          </Button>
          <Button
            variant="info"
            onClick={this.handleFireCreateIssue}
            disabled={this.state.isCreating}
          >
            Create
          </Button>
          <div className="spinner_container">
            {" "}
            {this.state.isCreating && <Spinner animation="grow" />}
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  render() {
    const isPdf = this.props.bookType === "pdf_books";

    return isPdf ? this.renderPdfCreator() : this.renderWebCreator();
  }
}

const mapState = (state, ownProps) => {
  const { issueList } = state;

  const isPdf = ownProps.bookType === "pdf_books";

  return {
    showCreateModal: isPdf
      ? issueList.showCreatePdfModal
      : issueList.showCreateWebModal
  };
};

const mapDispatch = {
  hideCreateAction,
  loadIssueRequestAction
};

export default connect(
  mapState,
  mapDispatch
)(CreateIssueModal);
